import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isBookingsPhone(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.BOOKINGS_PHONE && typeof label === 'string' && typeof value === 'string';
}
function _formatBookingsPhone(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatBookingsPhone(submission) {
  if (isBookingsPhone(submission)) {
    return _formatBookingsPhone(submission);
  }
  return undefined;
}
//# sourceMappingURL=bookings-phone-preview.js.map